import React, {Component} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDate from "../../../../modules/SimpleDate";
import M from "moment/moment";
import SimpleUploadImage from "../../../../modules/upload/SimpleUploadImage";

class MasterVoucherUser extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <SimpleModal
                title="Detail User Voucher"
                visible={this.props.visible}
                onClickClose={this.props.onClickClose}
                content={
                    <ModalContainer>
                        <div>
                            <div className="grid grid-2x gap-20px">
                                <div id="grid-1">
                                    <SimpleInput
                                        name="kodeVoucher"
                                        label="Kode Voucher"
                                        value={this.props.data.kodeVoucher}
                                        readOnly
                                    />
                                    <SimpleInput
                                        name="memberId"
                                        label="Member ID"
                                        value={this.props.data.memberId}
                                        readOnly
                                    />
                                </div>
                                <div id="grid-2">
                                    <SimpleInput
                                        name="voucherName"
                                        label="Voucher Name"
                                        value={this.props.data.voucherName}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="grid grid-2x gap-20px">
                                <div id="grid-1">
                                    <SimpleDate
                                        id="select_date_start_period"
                                        name="startPeriod"
                                        label="Start Berlaku"
                                        nextdate
                                        date={this.props.data.startDate || null}
                                        disabled
                                    />
                                    <SimpleInput
                                        name="voucherUniqueNo"
                                        label="No Unik Voucher"
                                        value={this.props.data.voucherUniqueNo}
                                        readOnly
                                    />
                                    <SimpleInput
                                        name="used"
                                        label="Used"
                                        value={this.props.data.used ? "Y" : "N"}
                                        readOnly
                                    />
                                </div>
                                <div id="grid-2">
                                    <SimpleDate
                                        id="select_date_end_period"
                                        name="endPeriod"
                                        label="End Berlaku"
                                        nextdate
                                        date={this.props.data.endDate || null}
                                        disabled
                                    />
                                    <SimpleUploadImage
                                        label="QR"
                                        id="qr_code"
                                        name="qrCode"
                                        value={this.props.data?.qrCode || null}
                                        readOnly
                                        category={""}
                                    />
                                </div>
                            </div>
                        </div>
                    </ModalContainer>
                }
            />
        )
    }
}

export default MasterVoucherUser;